import { useCallback } from 'react';
import { useAuthStore } from '@/stores/auth';
import * as authApi from '@/api/auth';

export function useAuth() {
    const { token, permissions, adminUser, isAuthenticated, logout: storeLogout } = useAuthStore();
    const storeLogin = useAuthStore((s) => s.login);

    const login = useCallback(
        async (username: string, password: string) => {
            const data = await authApi.login(username, password);
            storeLogin(data);
            return data;
        },
        [storeLogin]
    );

    const logout = useCallback(async () => {
        try {
            await authApi.logout();
        } finally {
            storeLogout();
        }
    }, [storeLogout]);

    const refreshMe = useCallback(async () => {
        const data = await authApi.getMe();
        useAuthStore.getState().setAdminUser(data.adminUser);
        useAuthStore.getState().setPermissions(data.permissions);
        return data;
    }, []);

    return {
        token,
        permissions,
        adminUser,
        isAuthenticated,
        login,
        logout,
        refreshMe,
    };
}
